import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { logoutUser } from '../../actions/authActions';
import Button from '../elements/Button';
import api from '../../api';

const Dashboard = () => {
  // redux variables
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  let history = useHistory();
  const [user, setUser] = useState({});

  useEffect(() => {
    if (auth.isAuthenticated) {
      console.log(auth.loading);
      const id = auth.user.id;
      console.log(auth.user);
      getUser(id);
    } else {
      // redirects a user back to home if they are not logged in
      history.push('/');
      console.log(auth.user);
    }
  }, [auth, history]);

  const getUser = (id) => {
    api
      .get(`auth/users/${id}`)
      .then((res) => setUser(res.data))
      .catch((err) => console.log(err));
  };

  const onLogoutClick = (e) => {
    e.preventDefault();
    dispatch(logoutUser());
  };

  return (
    <div>
      <h1>
        Hello there,{' '}
        <span className='text-color-primary'>{user.firstName}</span>
      </h1>
      <Button onClick={onLogoutClick}>Logout</Button>
    </div>
  );
};

export default Dashboard;
